<template>
  <div id="examredroom">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "examredroom"
};
</script>

<style scoped>
</style>